// src/pages/admin/UserModal.js
import React from 'react';
import { Modal, Descriptions, List, Button } from 'antd';

const UserModal = ({ visible, onClose, user, onEdit }) => {
  if (!user) return null;

  return (
    <Modal
      title={`User Details - ${user.name}`}
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="edit" type="primary" onClick={onEdit}>
          Edit User
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width={800}
    >
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Name">{user.name}</Descriptions.Item>
        <Descriptions.Item label="Role">{user.role}</Descriptions.Item>
        <Descriptions.Item label="Status">{user.status}</Descriptions.Item>
        <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
        <Descriptions.Item label="Phone">{user.phone}</Descriptions.Item>
        <Descriptions.Item label="Created At">{user.createdAt}</Descriptions.Item>
      </Descriptions>

      {/* Role-Specific Details */}
      {user.role === 'STUDENT' && (
        <>
          <h3>Courses</h3>
          <List
            dataSource={user.courses || []}
            renderItem={(course) => (
              <List.Item>
                {course.title} - {course.status} ({course.progress}%)
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />

          <h3>Challenges</h3>
          <List
            dataSource={user.challenges || []}
            renderItem={(challenge) => (
              <List.Item>
                {challenge.title} - {challenge.status} {challenge.score ? `(Score: ${challenge.score})` : ''}
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />

          <h3>Mentors</h3>
          <List
            dataSource={user.mentors || []}
            renderItem={(mentor) => (
              <List.Item>
                {mentor.name} (Expertise: {mentor.expertise})
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />

          <h3>Skills</h3>
          <List
            dataSource={user.skills || []}
            renderItem={(skill) => <List.Item>{skill}</List.Item>}
            bordered
            style={{ marginBottom: 16 }}
          />

          <h3>Projects</h3>
          <List
            dataSource={user.projects || []}
            renderItem={(project) => (
              <List.Item>
                {project.title} - {project.status}
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />
        </>
      )}

      {user.role === 'MENTOR' && (
        <>
          <h3>Mentees</h3>
          <List
            dataSource={user.mentees || []}
            renderItem={(mentee) => (
              <List.Item>
                {mentee.name} - Progress: {mentee.progress}
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />

          <h3>Courses Taught</h3>
          <List
            dataSource={user.coursesTaught || []}
            renderItem={(course) => (
              <List.Item>
                {course.title} (Students Enrolled: {course.studentsEnrolled})
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />
        </>
      )}

      {user.role === 'VENDOR' && (
        <>
          <h3>Products</h3>
          <List
            dataSource={user.products || []}
            renderItem={(product) => (
              <List.Item>
                {product.name} - {product.status}
              </List.Item>
            )}
            bordered
            style={{ marginBottom: 16 }}
          />
        </>
      )}
    </Modal>
  );
};

export default UserModal;